import React from 'react';
import { Signup } from '../../containers/Signup'

export const SignupPage = () => <Signup />;